import { render, staticRenderFns } from "./AddIcon.vue?vue&type=template&id=574b68ee&scoped=true"
import script from "./AddIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddIcon.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AddIcon.vue?vue&type=style&index=0&id=574b68ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574b68ee",
  null
  
)

export default component.exports